import { Injectable } from '@angular/core';
import {
  studentFeedback,
  StudentInternship,
  StudentInternshipDetailsModel,
} from 'common/models/page-models/student-side/internship-detail/student-internship-detail-data.model';
import { FormDataService } from '../../base-data-services/form-data.service';
import {
  API_METHODS,
  API_URL,
  OperationType,
} from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { editInfo } from 'common/models/utility-models/utility-interface';
import { environment } from 'src/environments/environment';
import { studentInternshipDataModel } from 'common/models/page-models/student-side/internship-detail/student-internship-detail-meta.model';
import { StudentInternShipKeyDetails } from 'common/models/page-models/student-details/student-internship-key-details-model';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class StudentInternshipDetailDataService extends FormDataService<StudentInternshipDetailsModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.StudentResponseOnInvite, http, ss);
  }

  createInstance(): StudentInternshipDetailsModel {
    // console.log(StudentInternshipDetailsModel);
    
    return new StudentInternshipDetailsModel();
  }

  override getEditUrlAndMethod(id: any): editInfo {
    const edit = {
      url: environment.apiUrl + API_URL.PreviewStudentInternshipDetails,
      method: API_METHODS.post,
    };
    return edit;
  }

  override getUpdatePayload(data) {
    // console.log(data);
    
    const payload = {
      id: data.transferData.id,
    };
    return payload;
  }

  override modifyAPIResponse(response: any) {
    return response.details;
  }

  override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {
    // console.log(type, 'isStudentContinued');

    if (type === 'update') {
      return environment.apiUrl + API_URL.studentFeedbackFormSubmit;
    } else {
      return environment.apiUrl +  this.getAPI_URL();;
    }
    // if (type === 'update') {
    //   return environment.apiUrl + API_URL.studentFeedbackFormSubmit;
    // } else {
    //   return environment.apiUrl +  this.getAPI_URL();;
    // }
  }

  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<StudentInternshipDetailsModel> {
    return new Promise<any>((resolve, reject) => {
      const postinternshipData = new StudentInternship();
      const postFeedback = new studentFeedback();
      // console.log(dataModel, metamodel, model, 'tabumber');
      if (metamodel.properties.tabNumber === 1) {
        postinternshipData.id = dataModel.id;
        postinternshipData.isStudentAvailable = dataModel.isStudentAvailable;
        // postinternshipData.id = dataModel.id;
        postinternshipData.studentExamStartDate = moment(
          model.studentExamStartDate
        ).format('YYYY-MM-DD HH:mm:ss');
        postinternshipData.studentExamEndDate = moment(
          model.studentExamEndDate
        ).format('YYYY-MM-DD HH:mm:ss');
        postinternshipData.studentSummerVacationStartDate = moment(
          model.studentSummerVacationStartDate
        ).format('YYYY-MM-DD HH:mm:ss');
        postinternshipData.studentSummerVacationEndDate = moment(
          model.studentSummerVacationEndDate
        ).format('YYYY-MM-DD HH:mm:ss');
        postinternshipData.studentAvailabilityRemark =
          model.studentAvailabilityRemark;
        postinternshipData.isExternalCompanyForInternship =
          dataModel.isExternalCompanyForInternship;
        postinternshipData.externalCompanyName =
          model.externalCompanyName ?? '';
        postinternshipData.externalCompanyLocation =
          model.externalCompanyLocation ?? '';
        postinternshipData.studentExpectedInternshipStartDate = moment(
          model.studentExpectedInternshipStartDate
        ).format('YYYY-MM-DD HH:mm:ss');
        postinternshipData.studentExpectedInternshipEndDate = moment(
          model.studentExpectedInternshipEndDate
        ).format('YYYY-MM-DD HH:mm:ss');
        // console.log(model, dataModel, metamodel, postinternshipData, 'tab');
        resolve(postinternshipData);
      }
      //  else if (metamodel.properties.tabNumber === 2) {
      //   postFeedback.id = dataModel.id;
      //   postFeedback.internshipCerty = '';
      //   postFeedback.isStudentContinued = dataModel.isStudentContinued;
      //   postFeedback.isStudentJoined = dataModel.isStudentJoined;
      //   postFeedback.reasonForNotJoined = model.reasonForNotJoined;
      //   postFeedback.reasonForNotContinued = model.reasonForNotContinued;
      //   postFeedback.feedbackQuestionResponse = [];

      //   Object.keys(dataModel.studentFeedback).forEach((key) => {
      //     const question = dataModel.studentFeedback[key];
      //     const answer = model[key];

      //     if (question.questionType === 3 && Array.isArray(answer)) {
      //       const responseItem = {
      //         questionId: question.id,
      //         questionType: question.questionType,
      //         answer: answer.filter(Boolean).length.toString(),
      //       };
      //       postFeedback.feedbackQuestionResponse.push(responseItem);
      //     }
      //   });
      //   console.log(postFeedback);

      //   resolve(postFeedback);

      //   //postFeedback.feedbackQuestionResponse=
      // }
      // console.log(metamodel.properties,'metamodel properties');
      
      if (metamodel.properties.tabNumber === 2) {
        
        postFeedback.id = dataModel.id;
        postFeedback.internshipCerty = metamodel.properties.file;
        postFeedback.isStudentContinued = dataModel.isStudentContinued;
        postFeedback.isStudentJoined = dataModel.isStudentJoined;
        postFeedback.reasonForNotJoined = model.reasonForNotJoined ?? '';
        postFeedback.reasonForNotContinued = model.reasonForNotContinued ?? '';
        postFeedback.feedbackQuestionResponse = [];
        // console.log(dataModel,'data model');
        // console.log(dataModel.studentFeedback,'Student feedback');

        Object.keys(dataModel.studentFeedback).forEach((key, index) => {
          // console.log("KEY",key,model,dataModel);
          const question = dataModel.studentFeedback[key];
          const answer = model[question.id];
        // console.log(model,'model');
        
          // console.log(`Processing Question ID: ${question.id}`);
          // console.log(`Question Type: ${question.questionType}`);
          // console.log(`Answer from model:`, answer);
        
          if (question.questionType === 3 && Array.isArray(answer)) {
            // console.log("QUESTION TYPE 3 Answer",answer);
            if((metamodel.properties.internshipEndDatePassed && metamodel.properties.isInternshipJoined) || (!metamodel.properties.internshipEndDatePassed && metamodel.properties.isInternshipCompletedFieldSubmitted)){
            const responseItem = {
              questionId: question.id,
              questionType: question.questionType,
              answer: answer.filter(Boolean).length.toString(),
            };
            // console.log('Response Item for Type 3:', responseItem);
            postFeedback.feedbackQuestionResponse.push(responseItem);
          }
          } 
          else if ([0, 1, 2].includes(question.questionType)) {
            // console.log("QUESTION TYPE 0,1,2 Answer",answer);
            if(metamodel.properties.internshipEndDatePassed && metamodel.properties.isInternshipJoined || (!metamodel.properties.internshipEndDatePassed && metamodel.properties.isInternshipCompletedFieldSubmitted)){
              const responseItem = {
                questionId: question.id,
                questionType: question.questionType,
                answer: answer ?? '', 
              };
              // console.log('Response Item for Types 0, 1, 2:', responseItem);
              postFeedback.feedbackQuestionResponse.push(responseItem);
            }
          } 
        });
      
        const formData = new FormData();
        formData.append('id', dataModel.id);
        formData.append('internshipCerty', postFeedback.internshipCerty);
        formData.append('isStudentContinued', postFeedback.isStudentContinued);
        formData.append('isStudentJoined', postFeedback.isStudentJoined);
        formData.append('reasonForNotJoined', postFeedback.reasonForNotJoined);
        formData.append('reasonForNotContinued', postFeedback.reasonForNotContinued);
      
        postFeedback.feedbackQuestionResponse.forEach((item, index) => {
          formData.append(`feedbackQuestionResponse[${index}][questionId]`, item.questionId.toString());
          formData.append(`feedbackQuestionResponse[${index}][questionType]`, item.questionType.toString());
          formData.append(`feedbackQuestionResponse[${index}][answer]`, item.answer);
        });
      
        // console.log('form data',formData);
        // console.log('postfeedback',postFeedback);
        
        resolve(formData);
        // resolve({});
      }
      
      return;
    
    });
  }


  // override beforePostData(
  //   model: any,
  //   metamodel: any,
  //   dataModel: any
  // ): Promise<StudentInternshipDetailsModel> {
  //   return new Promise<any>((resolve, reject) => {
  //     const postinternshipData = new StudentInternship();
  //     const postFeedback = new studentFeedback();
  //     console.log(dataModel, metamodel, model, 'tabumber');
  
  //     if (metamodel.properties.tabNumber === 1) {
  //       postinternshipData.id = dataModel.id;
  //       postinternshipData.isStudentAvailable = dataModel.isStudentAvailable;
  //       postinternshipData.studentExamStartDate = moment(
  //         model.studentExamStartDate
  //       ).format('YYYY-MM-DD HH:mm:ss');
  //       postinternshipData.studentExamEndDate = moment(
  //         model.studentExamEndDate
  //       ).format('YYYY-MM-DD HH:mm:ss');
  //       postinternshipData.studentSummerVacationStartDate = moment(
  //         model.studentSummerVacationStartDate
  //       ).format('YYYY-MM-DD HH:mm:ss');
  //       postinternshipData.studentSummerVacationEndDate = moment(
  //         model.studentSummerVacationEndDate
  //       ).format('YYYY-MM-DD HH:mm:ss');
  //       postinternshipData.studentAvailabilityRemark =
  //         model.studentAvailabilityRemark;
  //       postinternshipData.isExternalCompanyForInternship =
  //         dataModel.isExternalCompanyForInternship;
  //       postinternshipData.externalCompanyName = model.externalCompanyName ?? '';
  //       postinternshipData.externalCompanyLocation =
  //         model.externalCompanyLocation ?? '';
  //       postinternshipData.studentExpectedInternshipStartDate = moment(
  //         model.studentExpectedInternshipStartDate
  //       ).format('YYYY-MM-DD HH:mm:ss');
  //       postinternshipData.studentExpectedInternshipEndDate = moment(
  //         model.studentExpectedInternshipEndDate
  //       ).format('YYYY-MM-DD HH:mm:ss');
  //       console.log(model, dataModel, metamodel, postinternshipData, 'tab');
  //       resolve(postinternshipData); // Send postinternshipData as is
  //     } 
  //     if (metamodel.properties.tabNumber === 2) {
  //       postFeedback.id = dataModel.id;
  //       postFeedback.internshipCerty = '';
  //       postFeedback.isStudentContinued = dataModel.isStudentContinued;
  //       postFeedback.isStudentJoined = dataModel.isStudentJoined;
  //       postFeedback.reasonForNotJoined = model.reasonForNotJoined ?? '';
  //       postFeedback.reasonForNotContinued = model.reasonForNotContinued ?? '';
  //       postFeedback.feedbackQuestionResponse = [];
      
  //       // Prepare the feedbackQuestionResponse array
  //       Object.keys(dataModel.studentFeedback).forEach((key, index) => {
  //         const question = dataModel.studentFeedback[key];
  //         const answer = model[key];
      
  //         if (question.questionType === 3 && Array.isArray(answer)) {
  //           const responseItem = {
  //             questionId: question.id,
  //             questionType: question.questionType,
  //             answer: answer.filter(Boolean).length.toString(),
  //           };
  //           postFeedback.feedbackQuestionResponse.push(responseItem);
        
  //         }
  //       });
      
  //       const formData = new FormData();
  //       formData.append('id', dataModel.id);
  //       formData.append('internshipCerty', postFeedback.internshipCerty);
  //       formData.append('isStudentContinued', postFeedback.isStudentContinued);
  //       formData.append('isStudentJoined', postFeedback.isStudentJoined);
  //       formData.append('reasonForNotJoined', postFeedback.reasonForNotJoined);
  //       formData.append('reasonForNotContinued', postFeedback.reasonForNotContinued);
      
  //       // Add feedbackQuestionResponse in the desired format
  //       postFeedback.feedbackQuestionResponse.forEach((item, index) => {
  //         formData.append(`feedbackQuestionResponse[${index}][questionId]`, item.questionId.toString());
  //         formData.append(`feedbackQuestionResponse[${index}][questionType]`, item.questionType.toString());
  //         formData.append(`feedbackQuestionResponse[${index}][answer]`, item.answer);
  //       });
      
  //       // console.log([...formData.entries()], 'Formatted FormData');
  //       resolve(formData);
  //     }
      
  //     return;
  //   });
  // }
  
  studentFeedBackMapping() {}

  override getOperationType(data: any) {
    // console.log(data);
    
    if (data.isStudentAvailable) {
      return OperationType.CREATE;
    } else {
      return OperationType.UPDATE;
    }
  }

  override async postData(data: any): Promise<any> {
    return await super.postData(data, false);
  }
}
